import './spinner.scss';

import cn from 'classnames';
import React from 'react';

import { ISpinnerSize } from '../types';

interface ISpinner {
  size?: ISpinnerSize;
  className?: string;
}

const Spinner: React.FC<ISpinner> = ({ size = 'medium', className }) => {
  return <div className={cn(className, 'mm-common-spinner', `mm-common-spinner-${size}`)} />;
};

export { Spinner };
